export function insertScript(src: string, is_async?: boolean): HTMLElement {
  const script = document.createElement('script');
  if (is_async) {
    script.async = true;
  }
  script.defer = true;
  script.src = src;
  const S = document.getElementsByTagName('body')[0];
  S.insertBefore(script, S.nextSibling);
  return script;
}
